import overlayStyles from "../../styles/UI/overlay.module.css";
import useFocusTrap from "../../hooks/useFocusTrap";

const Overlay = ({
  children,
  clickAway,
  darkBackground,
  zIndex,
}: {
  children: React.ReactNode | React.ReactNode[];
  clickAway: () => void;
  darkBackground?: boolean;
  zIndex?: number;
}) => {
  const containerRef = useFocusTrap<HTMLElement>(clickAway);

  return (
    <section
      ref={containerRef}
      tabIndex={-1}
      role="dialog"
      aria-modal="true"
      className={overlayStyles.overlay}
      style={{
        backgroundColor: darkBackground ? "rgba(0,0,0, 0.3)" : "transparent",
        zIndex: zIndex || 1000,
      }}
      onClick={(event) => {
        if (event.target === event.currentTarget) clickAway();
      }}
    >
      {children}
    </section>
  );
};

export default Overlay;
